/// <amd-module name="Search/WorkItem/Flux/Stores/ZeroDataStore" />

import * as Constants from "Search/WorkItem/Constants";
import * as BaseZeroDataStore from "Search/Shared/Base/Stores/ZeroDataStore";
import { WorkItemResult, WorkItemSearchRequest, WorkItemSearchResponse } from "Search/LegacyWebApi/Contracts/WorkItem";
import { IResultsLoadedPayload } from "Search/Shared/Base/ActionsHub";
import { ISeedData } from "Search/Shared/Base/Types";
import { areQueriesEqual } from "Search/WorkItem/Utils";

export class ZeroDataStore extends BaseZeroDataStore.ZeroDataStore {
    constructor(changedEventName: string, data?: ISeedData<WorkItemResult>) {
        super(changedEventName);
        if (data && data.responseWithActivityId) {
            this.updateStoreState(data.responseWithActivityId.response as WorkItemSearchResponse);
        }
    }

    public onResultsLoaded(query: WorkItemSearchRequest, payload: IResultsLoadedPayload<WorkItemSearchResponse, WorkItemResult>): void {
        if (areQueriesEqual(query, payload.response.query)) {
            this.updateStoreState(payload.response);
            this.emitChanged();
        }
    }

    protected areQueriesSame(queryInState: WorkItemSearchRequest, queryInPayload: WorkItemSearchRequest): boolean {
        return areQueriesEqual(queryInState, queryInPayload)
    }

    private updateStoreState = (response: WorkItemSearchResponse): void => {
        if (response && response.results.values.length <= 0) {
            this._state.scenario = BaseZeroDataStore.getScenario(response.errors, response.results.count, Constants.WorkItemSearchTakeResults, false);
        }
    }
}